import { observer } from "mobx-react";
import { ICompareValueTypeComponentProps } from "../condition-field";
import StringCompareValueStore from "../../../../../../../stores/compare-value/string-compare-value-store";
import { TEXTAREA_VARIANTS, Textarea } from "../../../../../../../../../components/inputs/textarea/textarea";

const StringCompareValueField: React.FC<ICompareValueTypeComponentProps> = observer(({store, condition, operatorSelector}) => {
    const compareValueStore: StringCompareValueStore = store as StringCompareValueStore;

    return (
        <>
            {operatorSelector}

            <Textarea disabled={!condition.isEditMode} value={compareValueStore.value} onChange={(v) => compareValueStore.setValue(v as string)} variant={TEXTAREA_VARIANTS.FIT_CONTENT} placeholder={condition.placeholder} />
        </>
    );
});

export default StringCompareValueField;